import { AfterViewInit, Component, OnInit, QueryList, ViewChildren, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { FaqService } from './faq.service';

@Component({
  selector: 'faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class LandingFaqComponent implements OnInit, AfterViewInit , OnDestroy {
  initialContent;
  searchText = '';
  searchResults;

  @ViewChildren('contentList') contentList: QueryList<any>;

  constructor(
    private router: Router,
    private faqService: FaqService,
    ) {}

  ngOnInit() {
    this.initialContent = this.faqService.getFaqData();

    this.searchResults = [...this.initialContent];
  }

  get content() {
    return this.isSearching ? this.searchResults : this.initialContent;
  }

  ngAfterViewInit() {
    this.findLinks();
    this.contentList.changes.subscribe(() => {
      this.findLinks();
    });
  }

  findLinks() {
    document.querySelectorAll('.card-content a.in-faq-link').forEach(item => {
      item.addEventListener('click', ev => {
        ev.preventDefault();
        this.router.navigate([ev.currentTarget['href'].split('/').pop()]);
        window.scrollTo(0, 0);
      });
    });
  }

  filterResults() {
    this.searchResults = this.initialContent.filter(item => {
      return item.content.find(p => {
        return p.find(span => this.isIncluded(span.text));
      }) || this.isIncluded(item.title);
    }).map(item => {
      return {
        title: this.replaceText(item.title),
        content: item.content.map(p => {
          return p.map(span => ({text: this.replaceText(span.text), href: span.href ? span.href : null}));
        }),
      };
    });
  }

  replaceText(text) {
    return text.replace(
      new RegExp(this.searchText, 'gi'),
      str => `<span class="found-substring">${str}</span>`
    );
  }

  isIncluded(text) {
    return text.match(new RegExp(this.searchText, 'i'));
  }

  get isSearching() {
    return this.searchText.length > 0;
  }

  ngOnDestroy(): void {
    this.faqService.clearSubscriptions();
  }

}
